module.exports = __webpack_public_path__ + "media/fonts/outline-icons-89f9806b.svg";